export default __webpack_public_path__ + "static/media/ambient-bright-blue-green.23471ca4.jpg";